import React, { useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalContext';
import { SUBS, resolveRoute, sectionBase, canAccess } from './navConfig';
import { findReport } from '../pages/reports/reportsManifest';

// Horizontal sub-route strip that only renders when the active section
// has sub-pages. Hidden entirely otherwise (no empty tab bar).
//
// Reports is a special case: instead of a tab strip that grows with every new
// report, it navigates via the hub at /reports, so here we render a breadcrumb
// back to that hub when viewing an individual report.

const SubNav = () => {
  const nav = useNavigate();
  const { pathname } = useLocation();
  const { uinfo } = useContext(GlobalContext);
  const { section, sub } = resolveRoute(pathname);

  if (!section) return null;

  // Reports: breadcrumb back to the hub (no breadcrumb on the hub itself).
  if (section === 'reports') {
    if (!sub) return null;
    const report = findReport(sub);
    return (
      <div className="subnav subnav-crumb">
        <button type="button" className="crumb-back" onClick={() => nav('/reports')}>
          ‹ Reports
        </button>
        <span className="crumb-sep">/</span>
        <span className="crumb-current">{report?.label || sub}</span>
        {report?.code && <span className="pill crumb-code">{report.code}</span>}
      </div>
    );
  }

  const key = section === 'cog' ? 'settings' : section;
  const items = SUBS[key];
  if (!items?.length) return null;

  const status = uinfo?.Status;
  const visible = items.filter(it => canAccess(it.roles, status));
  if (!visible.length) return null;

  // Use the section's declared base so multi-segment bases (e.g.
  // /control-panel/customer-drift) link correctly back to their sub-pages.
  const base = sectionBase(section);

  return (
    <div className="subnav">
      {visible.map(it => {
        const active = (sub || '') === it.slug;
        const href = it.slug ? `${base}/${it.slug}` : base;
        return (
          <button
            key={it.slug || 'home'}
            type="button"
            className={`subnav-item ${active ? 'on' : ''}`}
            onClick={() => nav(href)}
          >
            {it.label}
          </button>
        );
      })}
    </div>
  );
};

export default SubNav;
